/**
 * Static Mindtime Explorer “Online Installer” download targets (PC Backup vs Pro/VM Backup).
 * Bump ?v= on URLs when replacing files on the CDN.
 */

export type ExplorerPlatformIconKey =
  | 'windows'
  | 'macos'
  | 'synology'
  | 'qnap'
  | 'ubuntu'
  | 'linuxRpm'
  | 'linuxSh';

export interface ExplorerInstallerEntry {
  id: string;
  label: string;
  downloadUrl: string;
  platform: ExplorerPlatformIconKey;
}

export const EXPLORER_PC_BACKUP_INSTALLERS: ExplorerInstallerEntry[] = [
  {
    id: 'pc-win',
    label: 'Windows',
    downloadUrl:
      'https://mindtime.eu/downloads/software/windows/pc_backup/acb-win-443-backup11.mindtime.nl-https-35323O.exe?v=1',
    platform: 'windows',
  },
  {
    id: 'pc-mac',
    label: 'Mac OS',
    downloadUrl:
      'https://mindtime.eu/downloads/software/macos/pc_backup/acb-mac-443-backup11.mindtime.nl-https-35323O.dmg?v=1',
    platform: 'macos',
  },
];

export const EXPLORER_PRO_VM_BACKUP_INSTALLERS: ExplorerInstallerEntry[] = [
  {
    id: 'pro-win',
    label: 'Windows',
    downloadUrl:
      'https://mindtime.eu/downloads/software/windows/vm_backup/obm-win-443-backup11.mindtime.nl-https-35323O.exe?v=1',
    platform: 'windows',
  },
  {
    id: 'pro-mac',
    label: 'Mac OS',
    downloadUrl:
      'https://mindtime.eu/downloads/software/macos/vm_backup/obm-mac-443-backup11.mindtime.nl-https-35323O.dmg?v=1',
    platform: 'macos',
  },
  {
    id: 'pro-synology',
    label: 'Synology',
    downloadUrl:
      'https://mindtime.eu/downloads/software/synology/vm_backup/obm-synology7-443-backup11.mindtime.nl-https-35323O.spk?v=1',
    platform: 'synology',
  },
  {
    id: 'pro-qnap',
    label: 'QNAP',
    downloadUrl:
      'https://bms3/fm.php?hash=0b6eead1&amp;file=obm-qnap-443-backup09.mindtime.nl-https-11535O.qpkg',
    platform: 'qnap',
  },
  {
    id: 'pro-linux-deb',
    label: 'Linux DEB',
    downloadUrl:
      'https://mindtime.eu/downloads/software/linux/deb/vm_backup/obm-linux-noarch-443-backup11.mindtime.nl-https-35323O.deb?v=1',
    platform: 'ubuntu',
  },
  {
    id: 'pro-linux-rpm',
    label: 'Linux RPM',
    downloadUrl:
      'https://mindtime.eu/downloads/software/linux/rpm/vm_backup/obm-linux-noarch-443-backup11.mindtime.nl-https-35323O.rpm?v=1',
    platform: 'linuxRpm',
  },
  {
    id: 'pro-linux-sh',
    label: 'Linux SH',
    downloadUrl:
      'https://bms3/fm.php?hash=0b6eead1&amp;file=obm-linux-443-backup09.mindtime.nl-https-11535O.sh',
    platform: 'linuxSh',
  },
];
